import './base'
import { ProjectPageLoader } from 'ppp'
import { mountOnId } from 'shared'

document.addEventListener('DOMContentLoaded', () => {
  mountOnId(ProjectPageLoader, 'ppp')
})
